<template>
	<modal ref="modal" title="Clone Company Form" :close_on_focus="!cloning" :no_overflow="true">
		<div class="form-group row">
			<div class="col-12">
				<label>Form</label>
			</div>
			<div class="col-12">
				<select v-bind:disabled="cloning" class="form-control border" v-model="selected_form">
					<option :value="null" selected hidden>--- Select a Form ---</option>
					<option v-if="!forms.length" :value="false" disabled>(No custom forms)</option>
					<option v-for="form in forms" :value="form.id">{{form.name}}</option>
				</select>
			</div>
		</div>
		<div v-if="!cloning" class="form-group row">
			<div class="col-12 text-right">
				<button class="btn btn-secondary" v-on:click="cancel()">Cancel</button>
				<button class="btn btn-primary ml-2" v-on:click="save()">Clone</button>
			</div>
		</div>
		<loader v-else></loader>
	</modal>
</template>

<script>
	import Modal from "../general_components/Modal";
	import Loader from "../general_components/Loader";
	export default {
		name: "CloneFromLibraryModal",
		components: {Loader, Modal},
		props: {
			forms: {
				type: Array,
				required: true
			},
			clone_url: {
				type: String,
				required: true
			}
		},
		data() {
			return {
				selected_form: null,
				cloning: false
			}
		},
		methods: {
			openModal(){
				this.$nextTick(function (){
					this.$refs.modal.openModal();
				})
			},
			cancel(){
				this.$refs.modal.closeModal(null, true);
			},
			save(){
				this.cloning = true;
				axios.post(this.clone_url.replace('?', this.selected_form))
					.then(response => {
						this.selected_form = null;
						this.cloning = false;

						this.$emit('cloned', response.data);
						this.$refs.modal.closeModal(null, true);
					})
					.catch(() => {
						this.selected_form = null;
						this.cloning = false;
						Vue.$toast.open({
                            message: 'Something went wrong!',
                            type: 'error'
                        });
					})
			}
		},
		watch: {
			selected_company(){
				this.loadForms();
			}
		}
	}
</script>
